import React from 'react'
import { PersonAffiliation } from '../../../types'
import PersonRoleBreakdown from './PersonRoleBreakdown'
import PersonRecentActivity from './PersonRecentActivity'

/**
 * Compact two-column overview for the person Overblik tab:
 * role distribution (left) and recent activity (right).
 */
interface PersonOverviewStripProps {
  affiliations: PersonAffiliation[]
  activityLimit?: number
}

const PersonOverviewStrip: React.FC<PersonOverviewStripProps> = ({
  affiliations,
  activityLimit = 5,
}) => (
  <div className="bg-paper border border-rule rounded-[10px] overflow-hidden grid grid-cols-1 sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] divide-y sm:divide-y-0 sm:divide-x divide-rule">
    <div className="py-[18px] px-[22px]">
      <PersonRoleBreakdown affiliations={affiliations} compact />
    </div>
    <div className="py-[18px] px-[22px] min-w-0">
      <PersonRecentActivity
        affiliations={affiliations}
        limit={activityLimit}
        viewAllTab="aktivitet"
      />
    </div>
  </div>
)

export default PersonOverviewStrip
